import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * Rahmen für die öffentlichen Seiten.
 *
 * Bewusst getrennt vom Dashboard-Rahmen: hier gibt es keine Navigation durch
 * Mandanten, sondern eine Kopfzeile mit einem einzigen Weg hinein und einen
 * Fuß mit den Pflichtangaben. Mobile First, die Kopfzeile bleibt einzeilig.
 */
export function PublicShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col">
      <header className="sticky top-0 z-30 border-b border-[var(--border)] bg-[var(--surface)]/95 backdrop-blur">
        <div className="mx-auto flex w-full max-w-5xl items-center justify-between gap-3 px-4 py-3 sm:px-6">
          <Link to="/" className="flex items-center gap-2.5">
            <img
              src="/brand/crumblemonster-96.webp"
              alt=""
              width={36}
              height={36}
              className="size-9 shrink-0"
              loading="eager"
              decoding="async"
            />
            <span className="text-[17px] font-semibold tracking-tight">ilovecookies</span>
          </Link>
          <Link
            to="/login"
            className="inline-flex min-h-10 items-center rounded-xl bg-brand-600 px-4 text-sm font-semibold text-white transition-colors hover:bg-brand-700"
          >
            Anmelden
          </Link>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-[var(--border)] bg-[var(--surface)]">
        <div className="mx-auto flex w-full max-w-5xl flex-col gap-3 px-4 py-6 text-sm text-[var(--text-muted)] sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <p>Consent-Verwaltung aus Neuss. Daten in Frankfurt am Main.</p>
          <nav className="flex flex-wrap gap-x-5 gap-y-2">
            <Link to="/impressum" className="min-h-11 py-2 hover:text-[var(--text)] hover:underline">
              Impressum
            </Link>
            <Link to="/datenschutz" className="min-h-11 py-2 hover:text-[var(--text)] hover:underline">
              Datenschutz
            </Link>
            <Link to="/agb" className="min-h-11 py-2 hover:text-[var(--text)] hover:underline">
              AGB
            </Link>
            <Link to="/login" className="min-h-11 py-2 hover:text-[var(--text)] hover:underline">
              Anmelden
            </Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
